import Vue from 'vue'
import Router from 'vue-router'
import vuex from 'vuex'

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Dashboard = () => import('@/views/Dashboard')

const Colors = () => import('@/views/theme/Colors')
const Typography = () => import('@/views/theme/Typography')

const Charts = () => import('@/views/charts/Charts')
const Widgets = () => import('@/views/widgets/Widgets')

// Views - Components
const Cards = () => import('@/views/base/Cards')
const Forms = () => import('@/views/base/Forms')
const Switches = () => import('@/views/base/Switches')
const Tables = () => import('@/views/base/Tables')
const Tabs = () => import('@/views/base/Tabs')
const Breadcrumbs = () => import('@/views/base/Breadcrumbs')
const Carousels = () => import('@/views/base/Carousels')
const Collapses = () => import('@/views/base/Collapses')
const Jumbotrons = () => import('@/views/base/Jumbotrons')
const ListGroups = () => import('@/views/base/ListGroups')
const Navs = () => import('@/views/base/Navs')
const Navbars = () => import('@/views/base/Navbars')
const Paginations = () => import('@/views/base/Paginations')
const Popovers = () => import('@/views/base/Popovers')
const ProgressBars = () => import('@/views/base/ProgressBars')
const Tooltips = () => import('@/views/base/Tooltips')

// table component

// Views - Buttons
const StandardButtons = () => import('@/views/buttons/StandardButtons')
const ButtonGroups = () => import('@/views/buttons/ButtonGroups')
const Dropdowns = () => import('@/views/buttons/Dropdowns')
const BrandButtons = () => import('@/views/buttons/BrandButtons')

// Views - Icons
const CoreUIIcons = () => import('@/views/icons/CoreUIIcons')
const Brands = () => import('@/views/icons/Brands')
const Flags = () => import('@/views/icons/Flags')

// Views - Notifications
const Alerts = () => import('@/views/notifications/Alerts')
const Badges = () => import('@/views/notifications/Badges')
const Modals = () => import('@/views/notifications/Modals')

// Views - Pages
const Page404 = () => import('@/views/pages/Page404')
const Page500 = () => import('@/views/pages/Page500')
const Login = () => import('@/views/pages/Login')
const MyPage = () => import('@/views/pages/MyPage')
const Register = () => import('@/views/pages/Register')

// Users
const Users = () => import('@/views/users/Users')
const User = () => import('@/views/users/User')

// paymanage
const PayManagementList = () => import('@/views/paymanage/PayManagementList')
const PayManagementListDual = () => import('@/views/paymanage/PayManagementListDual')
const PayManageInsert = () => import('@/views/paymanage/PayManageInsert')
const PayManageUpdate = () => import('@/views/paymanage/PayManageUpdate')
const PayManageUnpaid = () => import('@/views/paymanage/PayManageUnpaid')
const PayManageCharge = () => import('@/views/paymanage/PayManageCharge')
const PayManageExcelList = () => import('@/views/paymanage/PayManageExcelList')
const PayManageExcelUpload = () => import('@/views/paymanage/PayManageExcelUpload')
const PayManageExcelUploadProc = () => import('@/views/paymanage/PayManageExcelUploadProc')
const PayManageOfflineExcelProcUpload = () => import('@/views/paymanage/PayManageOfflineExcelUpload')
const PayManageOfflineExcelProcUploadProc = () => import('@/views/paymanage/PayManageOfflineExcelUploadProc')
const PayManageOfflineUnpaidExcelProcUpload = () => import('@/views/paymanage/PayManageOfflineUnpaidExcelUpload')
const PayManageOfflineUnpaidExcelProcUploadProc = () => import('@/views/paymanage/PayManageOfflineUnpaidExcelUploadProc')
const PayManageWellnessUp = () => import('@/views/paymanage/PayManageWellnessUp')
const PayManageWellnessInsert = () => import('@/views/paymanage/PayManageWellnessInsert')
const PayManageAlbumInsert = () => import('@/views/paymanage/PayManageAlbumInsert')
const PayManageAlbumUp = () => import('@/views/paymanage/PayManageAlbumUpdate')

// charge
const ChargeList = () => import('@/views/charge/ChargeList')
const ChargeRegist = () => import('@/views/charge/ChargeRegist')
const ChargeUpdate = () => import('@/views/charge/ChargeUpdate')

// paydetail
const PayDetailList = () => import('@/views/paydetail/PayDetailList')
const PayDetail = () => import('@/views/paydetail/PayDetail')

// nurse
const NurseList = () => import('@/views/nurse/NurseList')

// paydetail
const PayDetailCardChit = () => import('@/views/paydetail/PayDetailCardChit')

//master
const CompanyList = () => import('@/views/master/CompanyList')
const CompanyInsert = () => import('@/views/master/CompanyInsert')
const CompanyUpdate = () => import('@/views/master/CompanyUpdate')
const AdminList = () => import('@/views/master/AdminList')
const AdminInsert = () => import('@/views/master/AdminInsert')
const AdminUpdate = () => import('@/views/master/AdminUpdate')

//silverNote
const SilverNoteList = () => import('@/views/silverNote/SilverNoteList')


Vue.use(Router)

const requireAuth = () => (from, to, next) => {
  if(localStorage.getItem('accessToken') === null || localStorage.getItem('accessToken') === 'undefined'){
    return next('/login/login');
  } else {
    return next();
  }

  /* if (to.matched.some(record => record.meta.unauthorized) || VueCookies.get('token')){
     return next();
   }

   alert('로그인 해주세요');
   return next('/login');*/
}



export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes(),
  beforeEnter: requireAuth()
})

function configRoutes() {
  return [
    {
      path: '/',
      redirect: '/login',
      name: 'Login',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: 'login',
          name: 'Login',
          component: Login
        }
      ]
    },
    {
      path: '/card',
      redirect: '/card/cardchit',
      name: 'Card',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: 'cardchit/:payId',
          name: 'Cardchit',
          component: PayDetailCardChit
        }
      ]
    },
    {
      path: '/',
      redirect: '/paymanage/list',
      name: 'Home',
      beforeEnter: requireAuth(),
      component: TheContainer,
      children: [
        {
          path: 'paymanage',
          redirect: 'paymanage/list/',
          name: 'PayManage',
          beforeEnter: requireAuth(),
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'paymanagementlist',
              beforeEnter: requireAuth(),
              component: PayManagementList
            },
            {
              path: 'listdual',
              name: 'paymanagementlistdual',
              beforeEnter: requireAuth(),
              component: PayManagementListDual
            },
            {
              path: 'insert',
              name: 'paymanageinsert',
              beforeEnter: requireAuth(),
              component: PayManageInsert
            },
            {
              path: 'update/:custId',
              name: 'paymanageupdate',
              beforeEnter: requireAuth(),
              component: PayManageUpdate,
              props: true
            },
            {
              path: 'unpaid/:custId',
              name: 'paymanageunpaid',
              beforeEnter: requireAuth(),
              component: PayManageUnpaid,
              props: true
            },
            {
              path: 'charge/:custId',
              name: 'paymanagecharge',
              beforeEnter: requireAuth(),
              component: PayManageCharge
            },
            {
              path: 'excellist',
              name: 'excellist',
              beforeEnter: requireAuth(),
              component: PayManageExcelList
            },
            {
              path: 'excelupload',
              name: 'excelupload',
              beforeEnter: requireAuth(),
              component: PayManageExcelUpload
            },
            {
              path: 'exceluploadproc',
              name: 'exceluploadproc',
              beforeEnter: requireAuth(),
              component: PayManageExcelUploadProc
            },
            {
              path: 'offlinechargeexcel',
              name: 'offlinechargeexcel',
              beforeEnter: requireAuth(),
              component: PayManageOfflineExcelProcUpload
            },
            {
              path: 'offlinechargeexcelproc',
              name: 'offlinechargeexcelproc',
              beforeEnter: requireAuth(),
              component: PayManageOfflineExcelProcUploadProc
            },
            {
              path: 'offlineunpaidchargeexcel',
              name: 'offlineunpaidchargeexcel',
              beforeEnter: requireAuth(),
              component: PayManageOfflineUnpaidExcelProcUpload
            },
            {
              path: 'offlineunpaidchargeexcelproc',
              name: 'offlineunpaidchargeexcelproc',
              beforeEnter: requireAuth(),
              component: PayManageOfflineUnpaidExcelProcUploadProc
            },
            {
              path: 'paymanagewellnessup',
              name: 'paymanagewellnessup',
              beforeEnter: requireAuth(),
              component: PayManageWellnessUp
            },
            {
              path: 'paymanagewellnessinsert/:custId',
              name: 'paymanagewellnessinsert',
              beforeEnter: requireAuth(),
              component: PayManageWellnessInsert
            },
            {
              path: 'paymanagealbumup',
              name: 'paymanagealbumup',
              beforeEnter: requireAuth(),
              component: PayManageAlbumUp
            },
            {
              path: 'paymanagealbuminsert/:custId',
              name: 'paymanagealbuminsert',
              beforeEnter: requireAuth(),
              component: PayManageAlbumInsert
            }
          ]
        },
        {
          path: 'company',
          redirect: 'company/list',
          name: 'Company',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'companylist',
              beforeEnter: requireAuth(),
              component: CompanyList
            },
            {
              path: 'update/:companyId',
              name: 'companyupdate',
              beforeEnter: requireAuth(),
              component: CompanyUpdate
            },
            {
              path: 'insert',
              name: 'companyinsert',
              beforeEnter: requireAuth(),
              component: CompanyInsert
            }
          ]
        },
        {
          path: 'admin',
          redirect: 'admin/list',
          name: 'Company',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'adminlist',
              beforeEnter: requireAuth(),
              component: AdminList
            },
            {
              path: 'update/:adminId',
              name: 'adminupdate',
              beforeEnter: requireAuth(),
              component: AdminUpdate
            },
            {
              path: 'insert',
              name: 'admininsert',
              beforeEnter: requireAuth(),
              component: AdminInsert
            }
          ]
        },
        {
          path: '/myPage',
          redirect: '/myPage',
          name: 'MyPage',
          beforeEnter: requireAuth(),
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'myPage',
              name: 'MyPage',
              beforeEnter: requireAuth(),
              component: MyPage
            }
          ]
        },
        {
          path: 'charge',
          redirect: 'charge/list',
          name: 'Charge',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'chargelist',
              beforeEnter: requireAuth(),
              component: ChargeList
            },
            {
              path: 'chargeRegist',
              name: 'chargeRegist',
              beforeEnter: requireAuth(),
              component: ChargeRegist
            },
            {
              path: 'update/:chargeId',
              name: 'chargeUpdate',
              beforeEnter: requireAuth(),
              component: ChargeUpdate
            }
          ]
        },
        {
          path: 'nurse',
          redirect: 'Nurse/list',
          name: 'Nurse',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'nurselist',
              beforeEnter: requireAuth(),
              component: NurseList
            }
          ]
        },
        {
          path: 'silverNote',
          redirect: 'silverNote/list',
          name: 'silvernote',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'silvernotelist',
              beforeEnter: requireAuth(),
              component: SilverNoteList
            }
          ]
        },
        {
          path: 'paydetail',
          redirect: 'paydetail/list',
          name: 'PayDetail',
          beforeEnter: requireAuth(),
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'list',
              name: 'paydetaillist',
              beforeEnter: requireAuth(),
              component: PayDetailList
            },
            {
              path: 'detail/:payId',
              name: 'paydetail',
              beforeEnter: requireAuth(),
              component: PayDetail
            }
          ]
        },
        {
          path: 'theme',
          redirect: '/theme/colors',
          name: 'Theme',
          beforeEnter: requireAuth(),
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'colors',
              name: 'Colors',
              beforeEnter: requireAuth(),
              component: Colors
            },
            {
              path: 'typography',
              name: 'Typography',
              beforeEnter: requireAuth(),
              component: Typography
            }
          ]
        },
        {
          path: 'charts',
          name: 'Charts',
          beforeEnter: requireAuth(),
          component: Charts
        },
        {
          path: 'widgets',
          name: 'Widgets',
          beforeEnter: requireAuth(),
          component: Widgets
        },
        {
          path: 'silver/users',
          meta: {
            label: 'Users'
          },
          beforeEnter: requireAuth(),
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: '',
              name: 'Users',
              beforeEnter: requireAuth(),
              component: Users
            },
            {
              path: ':id',
              meta: {
                label: 'User Details'
              },
              name: 'User',
              beforeEnter: requireAuth(),
              component: User
            }
          ]
        },
        {
          path: 'base',
          redirect: '/base/cards',
          name: 'Base',
          beforeEnter: requireAuth(),
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'cards',
              name: 'Cards',
              beforeEnter: requireAuth(),
              component: Cards
            },
            {
              path: 'forms',
              name: 'Forms',
              component: Forms
            },
            {
              path: 'switches',
              name: 'Switches',
              component: Switches
            },
            {
              path: 'tables',
              name: 'Tables',
              component: Tables
            },
            {
              path: 'tabs',
              name: 'Tabs',
              component: Tabs
            },
            {
              path: 'breadcrumbs',
              name: 'Breadcrumbs',
              component: Breadcrumbs
            },
            {
              path: 'carousels',
              name: 'Carousels',
              component: Carousels
            },
            {
              path: 'collapses',
              name: 'Collapses',
              component: Collapses
            },
            {
              path: 'jumbotrons',
              name: 'Jumbotrons',
              component: Jumbotrons
            },
            {
              path: 'list-groups',
              name: 'List Groups',
              component: ListGroups
            },
            {
              path: 'navs',
              name: 'Navs',
              component: Navs
            },
            {
              path: 'navbars',
              name: 'Navbars',
              component: Navbars
            },
            {
              path: 'paginations',
              name: 'Paginations',
              component: Paginations
            },
            {
              path: 'popovers',
              name: 'Popovers',
              component: Popovers
            },
            {
              path: 'progress-bars',
              name: 'Progress Bars',
              component: ProgressBars
            },
            {
              path: 'tooltips',
              name: 'Tooltips',
              component: Tooltips
            }
          ]
        },
        {
          path: 'buttons',
          redirect: '/buttons/standard-buttons',
          name: 'Buttons',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'standard-buttons',
              name: 'Standard Buttons',
              component: StandardButtons
            },
            {
              path: 'button-groups',
              name: 'Button Groups',
              component: ButtonGroups
            },
            {
              path: 'dropdowns',
              name: 'Dropdowns',
              component: Dropdowns
            },
            {
              path: 'brand-buttons',
              name: 'Brand Buttons',
              component: BrandButtons
            }
          ]
        },
        {
          path: 'icons',
          redirect: '/icons/coreui-icons',
          name: 'CoreUI Icons',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'coreui-icons',
              name: 'Icons library',
              component: CoreUIIcons
            },
            {
              path: 'brands',
              name: 'Brands',
              component: Brands
            },
            {
              path: 'flags',
              name: 'Flags',
              component: Flags
            }
          ]
        },
        {
          path: 'notifications',
          redirect: '/notifications/alerts',
          name: 'Notifications',
          component: {
            render(c) {
              return c('router-view')
            }
          },
          children: [
            {
              path: 'alerts',
              name: 'Alerts',
              component: Alerts
            },
            {
              path: 'badges',
              name: 'Badges',
              component: Badges
            },
            {
              path: 'modals',
              name: 'Modals',
              component: Modals
            }
          ]
        }
      ]
    },
    {
      path: '/pages',
      redirect: '/pages/404',
      name: 'Pages',
      component: {
        render(c) {
          return c('router-view')
        }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        },
        {
          path: 'register',
          name: 'Register',
          component: Register
        }
      ]
    }
  ]
}

